import { OfferTimelineStageType } from 'api-paths-cas';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight, faXmark, faFile, faFilePlus, faPencil } from '@fortawesome/pro-regular-svg-icons';

export interface TimelineStageConfig {
  title: string;
  subtitle?: string;
  icon: IconProp;
}

export const timelineStageConfig: Record<OfferTimelineStageType, TimelineStageConfig> = {
  [OfferTimelineStageType.Applied]: {
    title: 'Application submitted',
    icon: faArrowRight,
  },
  [OfferTimelineStageType.Conditional]: {
    title: 'Conditional offer issued',
    subtitle: 'Conditional',
    icon: faArrowRight,
  },
  [OfferTimelineStageType.ConditionalReissued]: {
    title: 'Conditional offer reissued',
    subtitle: 'Conditional',
    icon: faFile,
  },
  [OfferTimelineStageType.Unconditional]: {
    title: 'Unconditional offer issued',
    subtitle: 'Unconditional',
    icon: faArrowRight,
  },
  [OfferTimelineStageType.UnconditionalReissued]: {
    title: 'Unconditional offer reissued',
    subtitle: 'Unconditional',
    icon: faFile,
  },
  [OfferTimelineStageType.Withdrawn]: {
    title: 'Offer withdrawn',
    icon: faXmark,
  },
  [OfferTimelineStageType.Rejected]: {
    title: 'Offer rejected',
    icon: faXmark,
  },
  [OfferTimelineStageType.ProgrammeCreated]: {
    title: 'Programme created',
    icon: faArrowRight,
  },
  [OfferTimelineStageType.NewInformation]: {
    title: 'Applicant has provided new information',
    icon: faFilePlus,
  },
  [OfferTimelineStageType.ProgrammeEdited]: {
    title: 'Programme edited',
    icon: faPencil,
  },
  [OfferTimelineStageType.PreOfferTasksRequested]: {
    title: 'Pre-offer tasks requested',
    icon: faArrowRight,
  },
  [OfferTimelineStageType.EnrolmentTasksRequested]: {
    title: 'Enrolment tasks requested',
    icon: faArrowRight,
  },
};
